module.exports = __webpack_public_path__ + "static/img/yWgKXe5A.022d4de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/horse-nest/yWgKXe5A.jpg
// module id = 4P20
// module chunks = 7